/**
 * Web only: when the browser reports a coarse primary pointer (a touch screen),
 * a small control's tap area grows to at least 44×44px without changing how it
 * looks. An invisible `::before` reaches 12px beyond the padding-box edge, or
 * farther where that is needed to reach 44px. The control is unchanged when the
 * browser reports a fine primary pointer.
 *
 * Put it on the control's own interactive root, which must not set its own
 * `::before`. The area lies over neighbours that aren't positioned, so a plain
 * link within about 12px loses that strip to the control. A later positioned
 * sibling keeps its own taps, and a clipping ancestor (`overflow-hidden`) cuts
 * the area off. Native uses `hitSlop`.
 */
export const touchTargetClassName = [
  "[@media(pointer:coarse)]:relative",
  "[@media(pointer:coarse)]:before:absolute",
  "[@media(pointer:coarse)]:before:inset-[min(-12px,calc(50%-22px))]",
  "[@media(pointer:coarse)]:before:content-['']",
].join(" ");

/**
 * The same coarse-pointer tap area for controls that sit close together, such as
 * buttons in a row or a stack: it grows only as far as 44px needs on each axis,
 * and not at all on an axis that is already 44px or longer. A neighbour 8px away
 * keeps its own edge, where the 12px reach above would take 4px of it.
 *
 * It doesn't position the root, so a caller's `absolute` or `fixed` still wins:
 * the root must already be positioned (the button base is `relative`).
 */
export const minTouchTargetClassName = [
  "[@media(pointer:coarse)]:before:absolute",
  "[@media(pointer:coarse)]:before:inset-[min(0px,calc(50%-22px))]",
  "[@media(pointer:coarse)]:before:content-['']",
].join(" ");
